import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";

// The catalogue of Jamora's features (Ordre 11): rubriques, features, pharmacy roles and the copy it was seeded from.
// `enabled` false (module off, or no right to read it) = nothing is requested.
export default function useJamoraCatalog(enabled = true) {
  const [data, setData] = useState({ sections: [], features: [], roles: [], copy: null, can_manage: false });
  const [status, setStatus] = useState(enabled ? "loading" : "off"); // off | loading | ready | error

  const reload = useCallback(async () => {
    if (!enabled) return;
    try {
      const { data: body } = await api.get("/training/catalog");
      setData(body);
      setStatus("ready");
    } catch (e) {
      setStatus("error");
    }
  }, [enabled]);

  useEffect(() => {
    setStatus(enabled ? "loading" : "off");
    reload();
  }, [enabled, reload]);

  const featureLabel = (code) => data.features.find((f) => f.code === code)?.label || code;
  return { ...data, status, reload, featureLabel };
}
